"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiToolSetup = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const events_1 = require("@front/components/form-parts/events");
const uuid_1 = require("uuid");
//@ts-ignore                
let rwsTemplate = T.html `<div class="api-tool-setup">
    <div class="form-group mb-3">
        <part-switch class="form-part" label="${'avatar.form.apiTools.enabled.label'.t()}"
            :value="${x => x.enabled}" name="apiToolsEnabled"></part-switch>
        <small class="form-text text-muted">${'avatar.form.apiTools.enabled.help'.t()}</small>
    </div>

    ${(0, fast_element_1.when)(x => x.enabled, (0, fast_element_1.html) `
    <div class="d-flex justify-content-between align-items-center mb-3">
        <h6>${'avatar.form.apiTools.list.title'.t()}</h6>
        <button type="button" class="btn btn-primary btn-sm" @click="${x => x.addToolEntry()}">
            <i class="simple-icon-plus mr-1"></i>${'avatar.form.apiTools.add'.t()}
        </button>
    </div>

    ${(0, fast_element_1.when)(x => !x.definitions || x.definitions.length === 0, (0, fast_element_1.html) `
    <div class="alert alert-info">
        <i class="simple-icon-info mr-2"></i>${'avatar.form.apiTools.empty'.t()}
    </div>
    <div class="d-flex justify-content-end mb-3">
        <button type="button" class="btn btn-primary btn-sm" @click="${x => x.addToolEntry()}">
            <i class="simple-icon-plus mr-1"></i>${'avatar.form.apiTools.add'.t()}
        </button>
    </div>
    `)}

    ${(0, fast_element_1.repeat)(x => x.definitions || [], (0, fast_element_1.html) `
    <div class="card mb-3 api-tool-entry">
        <div class="card-header d-flex justify-content-between align-items-center">
            <h6 class="mb-0">${definition => definition.name || 'avatar.form.apiTools.untitled'.t()}</h6>
            <button type="button" class="btn btn-danger btn-sm"
                @click="${(definition, c) => c.parent.removeToolEntry(definition)}">
                <i class="simple-icon-trash"></i>
            </button>
        </div>
        <div class="card-body">
            <div class="form-row">
                <div class="form-group col-md-6">
                    <part-input class="form-part" label="${'avatar.form.apiTools.name.label'.t()}"
                        :value="${definition => definition.name}"
                        name="apiToolName_${definition => definition.id}"
                        placeholder="${'avatar.form.apiTools.name.placeholder'.t()}"></part-input>
                </div>
                <div class="form-group col-md-3">
                    <part-select class="form-part" label="${'avatar.form.apiTools.method.label'.t()}"
                        :value="${definition => definition.method || 'POST'}"
                        name="apiToolMethod_${definition => definition.id}"
                        :options="${(definition, c) => c.parent.methodOptions}"></part-select>
                </div>
                <div class="form-group col-md-3">
                    <part-input class="form-part" label="${'avatar.form.apiTools.endpoint.label'.t()}"
                        :value="${definition => definition.endpoint}"
                        name="apiToolEndpoint_${definition => definition.id}"
                        placeholder="${'avatar.form.apiTools.endpoint.placeholder'.t()}"></part-input>
                </div>
            </div>

            <div class="form-row">
                <div class="form-group col-12">
                    <part-input class="form-part" label="${'avatar.form.apiTools.description.label'.t()}"
                        :value="${definition => definition.description || ''}"
                        name="apiToolDesc_${definition => definition.id}"
                        placeholder="${'avatar.form.apiTools.description.placeholder'.t()}"></part-input>
                    <small class="form-text text-muted">${'avatar.form.apiTools.description.help'.t()}</small>
                </div>
            </div>

            
            <div class="form-row mt-2">
                <div class="form-group col-12">
                    <part-switch class="form-part"
                        label="${'avatar.form.apiTools.authEnabled.label'.t()}"
                        :value="${definition => definition.authorizationEnabled}"
                        name="apiToolAuthEnabled_${definition => definition.id}"></part-switch>
                </div>
            </div>

            ${(0, fast_element_1.when)(definition => definition.authorizationEnabled, (0, fast_element_1.html) `
            <div class="form-row">
                <div class="form-group col-md-6">
                    <part-input class="form-part"
                        label="${'avatar.form.apiTools.authHeader.label'.t()}"
                        :value="${definition => definition.authorizationHeader || ''}"
                        name="apiToolAuthHeader_${definition => definition.id}"
                        placeholder="${'avatar.form.apiTools.authHeader.placeholder'.t()}"></part-input>
                </div>
                <div class="form-group col-md-6">
                    <div class="d-flex align-items-end">
                        <div class="flex-grow-1">
                            <part-input class="form-part"
                                label="${'avatar.form.apiTools.authKey.label'.t()}"
                                :value="${definition => definition.authorizationKey || ''}"
                                name="apiToolAuthKey_${definition => definition.id}"
                                type="${(definition, c) => c.parent.authKeyVisible[definition.id] ? 'text' : 'password'}"
                                placeholder="${'avatar.form.apiTools.authKey.placeholder'.t()}"></part-input>
                        </div>
                        <button type="button" class="btn btn-outline-secondary btn-sm ml-2 mb-1"
                            title="${'avatar.form.apiTools.authKey.toggle'.t()}"
                            @click="${(definition, c) => c.parent.toggleAuthKeyVisibility(definition.id)}">
                            <i class="simple-icon-${(definition, c) => c.parent.authKeyVisible[definition.id] ? 'lock' : 'eye'}"></i>
                        </button>
                    </div>
                </div>
            </div>
            `)}

            
            <div class="payload-fields mt-3">
                <div class="d-flex justify-content-between align-items-center mb-2">
                    <label class="mb-0"><strong>${'avatar.form.apiTools.payloadFields.title'.t()}</strong></label>
                    <button type="button" class="btn btn-outline-primary btn-sm"
                        @click="${(definition, c) => c.parent.addPayloadField(definition)}">
                        <i class="simple-icon-plus mr-1"></i>${'avatar.form.apiTools.payloadFields.add'.t()}
                    </button>
                </div>
                <small class="form-text text-muted mb-2">${'avatar.form.apiTools.payloadFields.description'.t()}</small>

                ${(0, fast_element_1.when)(definition => !definition.payloadFields || definition.payloadFields.length === 0, (0, fast_element_1.html) `
                <div class="alert alert-info small mb-2">
                    <i class="simple-icon-info mr-2"></i>${'avatar.form.apiTools.payloadFields.empty'.t()}
                </div>
                <div class="d-flex justify-content-end mb-2">
                    <button type="button" class="btn btn-outline-primary btn-sm"
                        @click="${(definition, c) => c.parent.addPayloadField(definition)}">
                        <i class="simple-icon-plus mr-1"></i>${'avatar.form.apiTools.payloadFields.add'.t()}
                    </button>
                </div>
                `)}

                ${(0, fast_element_1.repeat)(definition => definition.payloadFields || [], (0, fast_element_1.html) `
                <div class="payload-field-entry d-flex align-items-start">
                    <div class="flex-grow-1">
                        <div class="form-row">
                            <div class="form-group col-md-3 mb-1">
                                <part-input class="form-part"
                                    label="${'avatar.form.apiTools.payloadFields.name.label'.t()}"
                                    :value="${field => field.name}"
                                    name="apiToolFieldName_${(field, c) => c.parent.id + '__' + field.id}"
                                    placeholder="${'avatar.form.apiTools.payloadFields.name.placeholder'.t()}"></part-input>
                            </div>
                            <div class="form-group col-md-4 mb-1">
                                <part-input class="form-part"
                                    label="${'avatar.form.apiTools.payloadFields.desc.label'.t()}"
                                    :value="${field => field.description}"
                                    name="apiToolFieldDesc_${(field, c) => c.parent.id + '__' + field.id}"
                                    placeholder="${'avatar.form.apiTools.payloadFields.desc.placeholder'.t()}"></part-input>
                            </div>
                            <div class="form-group col-md-2 mb-1">
                                <part-select class="form-part"
                                    label="${'avatar.form.apiTools.payloadFields.type.label'.t()}"
                                    :value="${field => field.type || 'string'}"
                                    name="apiToolFieldType_${(field, c) => c.parent.id + '__' + field.id}"
                                    :options="${(field, c) => c.parentContext.parent.fieldTypeOptions}"></part-select>
                            </div>
                            <div class="form-group col-md-2 mb-1">
                                <part-switch class="form-part"
                                    label="${'avatar.form.apiTools.payloadFields.optional.label'.t()}"
                                    :value="${field => field.optional || false}"
                                    name="apiToolFieldOptional_${(field, c) => c.parent.id + '__' + field.id}"></part-switch>
                            </div>
                            <div class="form-group col-md-1 mb-1 d-flex align-items-end pb-1">
                                <button type="button" class="btn btn-outline-danger btn-sm"
                                    @click="${(field, c) => c.parentContext.parent.removePayloadField(c.parent, field)}">
                                    <i class="simple-icon-trash"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                `)}

                ${(0, fast_element_1.when)(definition => definition.payloadFields && definition.payloadFields.length > 0, (0, fast_element_1.html) `
                <div class="d-flex justify-content-end mt-2">
                    <button type="button" class="btn btn-outline-primary btn-sm"
                        @click="${(definition, c) => c.parent.addPayloadField(definition)}">
                        <i class="simple-icon-plus mr-1"></i>${'avatar.form.apiTools.payloadFields.add'.t()}
                    </button>
                </div>
                `)}
            </div>
        </div>
    </div>
    `)}

    ${(0, fast_element_1.when)(x => x.definitions && x.definitions.length > 0, (0, fast_element_1.html) `
    <div class="d-flex justify-content-end mt-2 mb-3">
        <button type="button" class="btn btn-primary btn-sm" @click="${x => x.addToolEntry()}">
            <i class="simple-icon-plus mr-1"></i>${'avatar.form.apiTools.add'.t()}
        </button>
    </div>
    `)}
    `)}
</div>
`;
require("./styles/layout.scss");
const styles = T.css `.api-tool-setup .api-tool-entry .payload-fields {
  background: #f8f9fa;
  border-radius: 0.375rem;
  padding: 15px;
}
.api-tool-setup .api-tool-entry .payload-fields .payload-field-entry {
  padding: 8px;
  border-bottom: 1px solid #dee2e6;
}
.api-tool-setup .api-tool-entry .payload-fields .payload-field-entry:last-child {
  border-bottom: none;
}`;
const shadowOptions = { "mode": "open" };
let ApiToolSetup = class ApiToolSetup extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.enabled = false;
        this.definitions = [];
        this.authKeyVisible = {};
        this.methodOptions = [
            { label: 'GET', value: 'GET' },
            { label: 'POST', value: 'POST' },
            { label: 'PUT', value: 'PUT' },
            { label: 'PATCH', value: 'PATCH' },
            { label: 'DELETE', value: 'DELETE' }
        ];
        this.fieldTypeOptions = [
            { label: 'String', value: 'string' },
            { label: 'Number', value: 'number' },
            { label: 'Boolean', value: 'boolean' },
            { label: 'Date', value: 'date' }
        ];
    }
    connectedCallback() {
        super.connectedCallback();
        this.on(events_1.inputEvents.changed, (event) => {
            event.stopPropagation();
            this.handleFieldChange(event.detail.fieldName, event.detail.value);
        });
    }
    setData(enabled, definitions) {
        this.enabled = enabled;
        this.definitions = definitions || [];
    }
    getData() {
        return {
            enabled: this.enabled,
            definitions: this.definitions
        };
    }
    addToolEntry() {
        const newEntry = {
            id: (0, uuid_1.v4)(),
            name: '',
            description: '',
            method: 'POST',
            endpoint: '',
            authorizationEnabled: false,
            authorizationHeader: '',
            authorizationKey: '',
            payloadFields: []
        };
        this.definitions = [...this.definitions, newEntry];
        this.emitChange();
    }
    removeToolEntry(definition) {
        this.definitions = this.definitions.filter(d => String(d.id) !== String(definition.id));
        this.emitChange();
    }
    addPayloadField(definition) {
        const newField = {
            id: (0, uuid_1.v4)(),
            name: '',
            description: '',
            type: 'string',
            optional: false
        };
        this.definitions = this.definitions.map(d => {
            if (String(d.id) !== String(definition.id))
                return d;
            return { ...d, payloadFields: [...(d.payloadFields || []), newField] };
        });
        this.emitChange();
    }
    removePayloadField(definition, field) {
        this.definitions = this.definitions.map(d => {
            if (String(d.id) !== String(definition.id))
                return d;
            return { ...d, payloadFields: d.payloadFields.filter(f => String(f.id) !== String(field.id)) };
        });
        this.emitChange();
    }
    handleFieldChange(fieldName, value) {
        if (fieldName === 'apiToolsEnabled') {
            this.enabled = value;
            this.emitChange();
            return;
        }
        const parts = fieldName.split('_');
        if (parts.length < 2)
            return;
        const prefix = parts[0];
        // Handle payload field changes: apiToolFieldName_<definitionId>__<fieldId> or apiToolFieldDesc_<definitionId>__<fieldId>
        if (prefix === 'apiToolFieldName' || prefix === 'apiToolFieldDesc' || prefix === 'apiToolFieldType' || prefix === 'apiToolFieldOptional') {
            const ids = parts.slice(1).join('_');
            const [definitionId, fieldId] = ids.split('__');
            this.definitions = this.definitions.map(d => {
                if (String(d.id) !== definitionId)
                    return d;
                return {
                    ...d,
                    payloadFields: d.payloadFields.map(f => {
                        if (String(f.id) !== fieldId)
                            return f;
                        const updated = { ...f };
                        if (prefix === 'apiToolFieldName')
                            updated.name = value;
                        if (prefix === 'apiToolFieldDesc')
                            updated.description = value;
                        if (prefix === 'apiToolFieldType')
                            updated.type = value;
                        if (prefix === 'apiToolFieldOptional')
                            updated.optional = value;
                        return updated;
                    })
                };
            });
            this.emitChange();
            return;
        }
        // Handle tool-level fields
        const definitionId = parts.slice(1).join('_');
        this.definitions = this.definitions.map(d => {
            if (String(d.id) !== definitionId)
                return d;
            const updated = { ...d };
            switch (prefix) {
                case 'apiToolName':
                    updated.name = value;
                    break;
                case 'apiToolEndpoint':
                    updated.endpoint = value;
                    break;
                case 'apiToolMethod':
                    updated.method = value;
                    break;
                case 'apiToolDesc':
                    updated.description = value;
                    break;
                case 'apiToolAuthEnabled':
                    updated.authorizationEnabled = value;
                    if (!value) {
                        updated.authorizationHeader = '';
                        updated.authorizationKey = '';
                    }
                    break;
                case 'apiToolAuthHeader':
                    updated.authorizationHeader = value;
                    break;
                case 'apiToolAuthKey':
                    updated.authorizationKey = value;
                    break;
            }
            return updated;
        });
        this.emitChange();
    }
    toggleAuthKeyVisibility(definitionId) {
        this.authKeyVisible = {
            ...this.authKeyVisible,
            [definitionId]: !this.authKeyVisible[definitionId]
        };
    }
    emitChange() {
        // Strip frontend-generated UUID ids from new entries (not yet saved to DB).
        // DB ids are numeric strings; UUIDs are not.
        const definitionsForEmit = this.definitions.map(d => {
            if (d.id && !/^\d+$/.test(String(d.id))) {
                const { id, ...rest } = d;
                return rest;
            }
            return d;
        });
        this.$emit('api-tools-changed', {
            enabled: this.enabled,
            definitions: definitionsForEmit
        });
    }
};
exports.ApiToolSetup = ApiToolSetup;
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], ApiToolSetup.prototype, "enabled", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], ApiToolSetup.prototype, "definitions", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_a = typeof Record !== "undefined" && Record) === "function" ? _a : Object)
], ApiToolSetup.prototype, "authKeyVisible", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], ApiToolSetup.prototype, "methodOptions", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], ApiToolSetup.prototype, "fieldTypeOptions", void 0);
exports.ApiToolSetup = ApiToolSetup = __decorate([
    (0, client_1.RWSView)('api-tool-setup', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], ApiToolSetup);
ApiToolSetup.defineComponent();
